import { formatDate, MOMENT_FORMATS } from '../../../utils/dateFormat';

export const formatDateRangeLabel = (startDate, endDate, { compact = false } = {}) => {
  if (!startDate || !endDate) {
    return 'Select Date Range';
  }

  if (compact) {
    const start = formatDate(startDate, MOMENT_FORMATS.DATE_SHORT);
    const endFormat =
      startDate.getFullYear() !== endDate.getFullYear()
        ? `${MOMENT_FORMATS.DATE_SHORT}, YY`
        : MOMENT_FORMATS.DATE_SHORT;
    const end = formatDate(endDate, endFormat);
    return `${start} – ${end}`;
  }

  return `${formatDate(startDate, MOMENT_FORMATS.DATE)} - ${formatDate(endDate, MOMENT_FORMATS.DATE)}`;
};
